import { ApolloError } from '@apollo/client';
import { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Flex, Box, Text, Card } from 'rebass/styled-components'
import styled from 'styled-components';
import { InputNoForm } from '../../components/TextInput';
import { ISearchPatient, ISearchProviderPatientsByNameOutput } from '../../graphql/types/queries/patient';
import { Constants } from '../../utils/Constants';
import { getMockedFirstName, getMockedLastName, getMockedPhone } from '../../utils/mocks';

interface ISearchResultsProps {
  searched: string
  data: ISearchProviderPatientsByNameOutput | undefined
  error: ApolloError | undefined
}

const HoverableCard = styled(Card)`
  transition:all 0.3s ease;
  flex: initial;
`

const Row = ({ row, onGoToMessages, onGoToProfile, hoveredId, setHover }: { row: ISearchPatient, onGoToMessages: () => void, setHover: (id: string | null) => void, onGoToProfile: () => void, hoveredId: string | null }) => {

  let firstName = row.firstName
  let lastName = row.lastName
  let homePhone = row.homePhone
  let mobilePhone = row.mobilePhone

  if (Constants.IS_SCRAMBLING_MODE) {
    firstName = getMockedFirstName()
    lastName = getMockedLastName()
    homePhone = getMockedPhone()
    mobilePhone = getMockedPhone()
  }

  return (
    <HoverableCard mb={2} style={{ opacity: !hoveredId || hoveredId === row.patientId?.toString() ? 1 : 0.7, boxShadow: !hoveredId || hoveredId === row.patientId?.toString() ? '0px 4px 20px rgb(0 0 0 / 10%)' : '0px 4px 20px rgb(0 0 0 / 0%)' }} onMouseEnter={() => setHover((row.patientId || '').toString())} onMouseLeave={() => setHover(null)}>
      <Flex style={{ width: '100%', minHeight: '82px', padding: '18px 12px' }}>
        <Flex flex={1} flexDirection={['column', 'row', 'row']}>
          <Flex flex={1}>
            <Box width={'80px'} style={{ alignSelf: 'center' }}>
              <Text textAlign={'center'} style={{ color: '#7992B3', fontSize: '12px' }}>{row.patientId}</Text>
            </Box>
            <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>
            <Box style={{ flex: 1, paddingLeft: '12px', alignSelf: 'center' }}>
              <Text style={{ color: '#7992B3', fontSize: '12px' }}>{`${firstName}`}</Text>
            </Box>
            <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>
            <Box style={{ flex: 1, paddingLeft: '12px', alignSelf: 'center' }}>
              <Text style={{ color: '#7992B3', fontSize: '12px' }}>{`${lastName}`}</Text>
            </Box>
          </Flex>
          <Box style={{ background: '#E2E2E2' }} width={[0, '1px', '1px']}></Box>
          <Flex flex={1} justifyContent={['center', '', '']} mt={[2, 0, 0]}>
            <Box flex={['initial', 1, 1]} paddingRight={['12px', '', '']} style={{ paddingLeft: '12px', alignSelf: 'center' }}>
              <Text style={{ color: '#7992B3', fontSize: '12px' }}>{`${row.dob}`}</Text>
            </Box>
            <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>
            <Flex width={['', '280px', '280px']} style={{ paddingLeft: '12px', alignSelf: 'center' }}>
              <Flex flexDirection={'column'} flex={1} justifyContent='center'>
                <Text style={{ color: '#7992B3', fontSize: '12px' }}>{homePhone || mobilePhone}</Text>
              </Flex>
            </Flex>
            <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>
            <Flex width={['', '280px', '280px']} style={{ paddingLeft: '12px', alignSelf: 'center' }}>
              <Flex flexDirection={'column'} flex={1} justifyContent='center'>
                <Text style={{ color: '#7992B3', fontSize: '12px' }}>{row.state}</Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex style={{ paddingLeft: '24px' }} alignItems='center' flexDirection={['column', 'row', 'row']}>
          <svg style={{ cursor: 'pointer' }} onClick={onGoToMessages} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 3H5C4.20435 3 3.44129 3.31607 2.87868 3.87868C2.31607 4.44129 2 5.20435 2 6V21C2.00031 21.1772 2.04769 21.3511 2.1373 21.504C2.22691 21.6569 2.35553 21.7832 2.51 21.87C2.65946 21.9547 2.82821 21.9995 3 22C3.17948 21.9999 3.35564 21.9516 3.51 21.86L8 19.14C8.16597 19.0412 8.35699 18.9926 8.55 19H19C19.7956 19 20.5587 18.6839 21.1213 18.1213C21.6839 17.5587 22 16.7956 22 16V6C22 5.20435 21.6839 4.44129 21.1213 3.87868C20.5587 3.31607 19.7956 3 19 3ZM8 12C7.80222 12 7.60888 11.9414 7.44443 11.8315C7.27998 11.7216 7.15181 11.5654 7.07612 11.3827C7.00043 11.2 6.98063 10.9989 7.01921 10.8049C7.0578 10.6109 7.15304 10.4327 7.29289 10.2929C7.43275 10.153 7.61093 10.0578 7.80491 10.0192C7.99889 9.98063 8.19996 10.0004 8.38268 10.0761C8.56541 10.1518 8.72159 10.28 8.83147 10.4444C8.94135 10.6089 9 10.8022 9 11C9 11.2652 8.89464 11.5196 8.70711 11.7071C8.51957 11.8946 8.26522 12 8 12ZM12 12C11.8022 12 11.6089 11.9414 11.4444 11.8315C11.28 11.7216 11.1518 11.5654 11.0761 11.3827C11.0004 11.2 10.9806 10.9989 11.0192 10.8049C11.0578 10.6109 11.153 10.4327 11.2929 10.2929C11.4327 10.153 11.6109 10.0578 11.8049 10.0192C11.9989 9.98063 12.2 10.0004 12.3827 10.0761C12.5654 10.1518 12.7216 10.28 12.8315 10.4444C12.9414 10.6089 13 10.8022 13 11C13 11.2652 12.8946 11.5196 12.7071 11.7071C12.5196 11.8946 12.2652 12 12 12ZM16 12C15.8022 12 15.6089 11.9414 15.4444 11.8315C15.28 11.7216 15.1518 11.5654 15.0761 11.3827C15.0004 11.2 14.9806 10.9989 15.0192 10.8049C15.0578 10.6109 15.153 10.4327 15.2929 10.2929C15.4327 10.153 15.6109 10.0578 15.8049 10.0192C15.9989 9.98063 16.2 10.0004 16.3827 10.0761C16.5654 10.1518 16.7216 10.28 16.8315 10.4444C16.9414 10.6089 17 10.8022 17 11C17 11.2652 16.8946 11.5196 16.7071 11.7071C16.5196 11.8946 16.2652 12 16 12Z" fill="#344F7A" />
          </svg>
          <Box width={[0, '24px', '24px']} />
          <svg onClick={onGoToProfile} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }}>
            <path d="M28.0078 20.1123L28.0049 20.1094L28.0019 20.1064C26.7099 17.373 24.709 15.9668 22.0459 15.9668C19.3828 15.9668 17.3818 17.376 16.0869 20.1064V20.1094C15.9287 20.4463 15.9287 20.8389 16.0869 21.1758C17.3818 23.9062 19.3828 25.3125 22.0459 25.3125C24.709 25.3125 26.7099 23.9033 28.0049 21.1729C28.1631 20.8359 28.1631 20.4463 28.0078 20.1123ZM22.0459 23.4375C20.2266 23.4375 18.8994 22.5586 17.9121 20.6396C18.8965 18.7207 20.2266 17.8418 22.0459 17.8418C23.8652 17.8418 25.1924 18.7207 26.1797 20.6396C25.1953 22.5586 23.8652 23.4375 22.0459 23.4375Z" fill="#344F7A" />
            <path d="M20.4199 20.6543C20.4199 21.0894 20.5928 21.5067 20.9004 21.8144C21.2081 22.1221 21.6254 22.2949 22.0605 22.2949C22.4957 22.2949 22.913 22.1221 23.2206 21.8144C23.5283 21.5067 23.7012 21.0894 23.7012 20.6543C23.7012 20.2192 23.5283 19.8019 23.2206 19.4942C22.913 19.1865 22.4957 19.0137 22.0605 19.0137C21.6254 19.0137 21.2081 19.1865 20.9004 19.4942C20.5928 19.8019 20.4199 20.2192 20.4199 20.6543ZM3.98438 6.79688H24.6094V14.209H26.7188V5.625C26.7188 5.10645 26.2998 4.6875 25.7812 4.6875H2.8125C2.29395 4.6875 1.875 5.10645 1.875 5.625V20.8594C1.875 21.3779 2.29395 21.7969 2.8125 21.7969H13.125V19.6875H3.98438V6.79688Z" fill="#344F7A" />
            <path d="M21.2373 9.90528L20.1592 8.82715C20.0683 8.73633 19.9189 8.73633 19.8281 8.82715L14.4433 14.2178L11.9209 11.6924C11.8301 11.6016 11.6807 11.6016 11.5898 11.6924L7.3623 15.9199C7.27148 16.0108 7.27148 16.1602 7.3623 16.251L8.44043 17.3291C8.53125 17.4199 8.68066 17.4199 8.77148 17.3291L11.7539 14.3467L14.2764 16.8721C14.3672 16.9629 14.5166 16.9629 14.6074 16.8721L21.2373 10.2363C21.331 10.1455 21.331 9.9961 21.2373 9.90528Z" fill="#344F7A" />
          </svg>
        </Flex>
      </Flex>
    </HoverableCard>
  )
}

type TSortColumn = 'ID' | 'FN' | 'LN' | 'DOB' | null
type TSortDirection = 'ASC' | 'DESC'

const Header = ({ sortedColumn, sortDirection, changeSort, filterBy, filter, setFilter, setFilterBy }: { filterBy: TSortColumn, filter: string | null | undefined, sortedColumn: TSortColumn, setFilter: (v: string | null) => void, sortDirection: TSortDirection, setFilterBy: (filterBy: TSortColumn) => void, changeSort: (sortedColumn: TSortColumn) => void }) => {
  return (
    <>
      <Flex style={{ width: '100%', minHeight: '40px', padding: '18px 12px' }} display={['flex !important', 'none !important', 'none !important']}>

      </Flex>
      <Flex style={{ width: '100%', minHeight: '82px', padding: '18px 12px' }} display={['none !important', 'flex !important', 'flex !important']}>
        <Box width={'80px'} style={{ alignSelf: 'center' }}>
          <Flex>
            <Flex flexDirection={'row'} justifyContent='center' flex={1}>
              <svg onClick={() => {
                if (filterBy === 'ID') {
                  setFilterBy(null)
                  setFilter(null)
                } else {
                  setFilterBy('ID')
                  setFilter(null)
                }
              }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.75 15.75L12.3855 12.3795L15.75 15.75ZM14.25 7.875C14.25 9.56576 13.5784 11.1873 12.3828 12.3828C11.1873 13.5784 9.56576 14.25 7.875 14.25C6.18424 14.25 4.56274 13.5784 3.36719 12.3828C2.17165 11.1873 1.5 9.56576 1.5 7.875C1.5 6.18424 2.17165 4.56274 3.36719 3.36719C4.56274 2.17165 6.18424 1.5 7.875 1.5C9.56576 1.5 11.1873 2.17165 12.3828 3.36719C13.5784 4.56274 14.25 6.18424 14.25 7.875V7.875Z" stroke="#344F7A" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round" />
              </svg>

              <Text textAlign={'center'} style={{ color: '#7992B3', fontSize: '12px' }} ml={2}>ID</Text>
            </Flex>
            <Flex flexDirection={'column'} justifyContent='center' style={{ marginRight: '6px' }} onClick={() => changeSort('ID')}>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.2501 4.71872L5.53135 0.999975C5.2376 0.706226 4.7626 0.706226 4.47197 0.999975L0.750099 4.71872C0.278225 5.1906 0.612599 5.99997 1.28135 5.99997H8.71885C9.3876 5.99997 9.72197 5.1906 9.2501 4.71872Z" fill={sortedColumn === 'ID' && sortDirection === 'ASC' ? "#F6A293" : "#344F7A"} fill-opacity={sortedColumn === 'ID' && sortDirection === 'ASC' ? 1 : 0.4} />
              </svg>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '2px' }}>
                <path d="M0.750147 2.06094L4.4689 5.77969C4.76265 6.07344 5.23765 6.07344 5.52827 5.77969L9.25014 2.06094C9.72202 1.58906 9.38764 0.77969 8.71889 0.77969L1.2814 0.779691C0.612648 0.779691 0.278273 1.58907 0.750147 2.06094Z" fill={sortedColumn === 'ID' && sortDirection === 'DESC' ? "#F6A293" : "#344F7A"} fill-opacity={sortedColumn === 'ID' && sortDirection === 'DESC' ? 1 : 0.4} />
              </svg>
            </Flex>
          </Flex>
          {filterBy === 'ID' && (
            <InputNoForm type="search" style={{
              padding: '2px 6px',
              marginTop: '6px',
              border: '1px solid #7992B3',
            }} value={filter || ''} onChange={(e: any) => setFilter(e.target.value)} />
          )}
        </Box>
        <Box style={{ width: '1px', background: 'transparent' }}></Box>
        <Box style={{ flex: 1, paddingLeft: '12px', alignSelf: 'center' }}>
          <Flex>
            <Flex flexDirection={'row'} flex={1}>
              <svg onClick={() => {
                if (filterBy === 'FN') {
                  setFilterBy(null)
                  setFilter(null)
                } else {
                  setFilterBy('FN')
                  setFilter(null)
                }
              }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.75 15.75L12.3855 12.3795L15.75 15.75ZM14.25 7.875C14.25 9.56576 13.5784 11.1873 12.3828 12.3828C11.1873 13.5784 9.56576 14.25 7.875 14.25C6.18424 14.25 4.56274 13.5784 3.36719 12.3828C2.17165 11.1873 1.5 9.56576 1.5 7.875C1.5 6.18424 2.17165 4.56274 3.36719 3.36719C4.56274 2.17165 6.18424 1.5 7.875 1.5C9.56576 1.5 11.1873 2.17165 12.3828 3.36719C13.5784 4.56274 14.25 6.18424 14.25 7.875V7.875Z" stroke="#344F7A" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round" />
              </svg>

              <Text style={{ color: '#7992B3', fontSize: '12px' }} ml={2}>First Name</Text>
            </Flex>
            <Flex flexDirection={'column'} justifyContent='center' style={{ marginRight: '6px' }} onClick={() => changeSort('FN')}>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.2501 4.71872L5.53135 0.999975C5.2376 0.706226 4.7626 0.706226 4.47197 0.999975L0.750099 4.71872C0.278225 5.1906 0.612599 5.99997 1.28135 5.99997H8.71885C9.3876 5.99997 9.72197 5.1906 9.2501 4.71872Z" fill={sortedColumn === 'FN' && sortDirection === 'ASC' ? "#F6A293" : "#344F7A"} fill-opacity={sortedColumn === 'FN' && sortDirection === 'ASC' ? 1 : 0.4} />
              </svg>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '2px' }}>
                <path d="M0.750147 2.06094L4.4689 5.77969C4.76265 6.07344 5.23765 6.07344 5.52827 5.77969L9.25014 2.06094C9.72202 1.58906 9.38764 0.77969 8.71889 0.77969L1.2814 0.779691C0.612648 0.779691 0.278273 1.58907 0.750147 2.06094Z" fill={sortedColumn === 'FN' && sortDirection === 'DESC' ? "#F6A293" : "#344F7A"} fill-opacity={sortedColumn === 'FN' && sortDirection === 'DESC' ? 1 : 0.4} />
              </svg>
            </Flex>
          </Flex>
          {filterBy === 'FN' && (
            <InputNoForm type="search" style={{
              padding: '2px 6px',
              marginTop: '6px',
              border: '1px solid #7992B3',
            }} value={filter || ''} onChange={(e: any) => setFilter(e.target.value)} />
          )}
        </Box>
        <Box style={{ width: '1px', background: 'transparent' }}></Box>
        <Box style={{ flex: 1, paddingLeft: '12px', alignSelf: 'center' }}>
          <Flex>
            <Flex flexDirection={'row'} flex={1}>
              <svg onClick={() => {
                if (filterBy === 'LN') {
                  setFilterBy(null)
                  setFilter(null)
                } else {
                  setFilterBy('LN')
                  setFilter(null)
                }
              }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.75 15.75L12.3855 12.3795L15.75 15.75ZM14.25 7.875C14.25 9.56576 13.5784 11.1873 12.3828 12.3828C11.1873 13.5784 9.56576 14.25 7.875 14.25C6.18424 14.25 4.56274 13.5784 3.36719 12.3828C2.17165 11.1873 1.5 9.56576 1.5 7.875C1.5 6.18424 2.17165 4.56274 3.36719 3.36719C4.56274 2.17165 6.18424 1.5 7.875 1.5C9.56576 1.5 11.1873 2.17165 12.3828 3.36719C13.5784 4.56274 14.25 6.18424 14.25 7.875V7.875Z" stroke="#344F7A" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round" />
              </svg>

              <Text style={{ color: '#7992B3', fontSize: '12px' }} ml={2}>Last Name</Text>
            </Flex>
            <Flex flexDirection={'column'} justifyContent='center' style={{ marginRight: '6px' }} onClick={() => changeSort('LN')}>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.2501 4.71872L5.53135 0.999975C5.2376 0.706226 4.7626 0.706226 4.47197 0.999975L0.750099 4.71872C0.278225 5.1906 0.612599 5.99997 1.28135 5.99997H8.71885C9.3876 5.99997 9.72197 5.1906 9.2501 4.71872Z" fill={sortedColumn === 'LN' && sortDirection === 'ASC' ? "#F6A293" : "#344F7A"} fill-opacity={sortedColumn === 'LN' && sortDirection === 'ASC' ? 1 : 0.4} />
              </svg>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '2px' }}>
                <path d="M0.750147 2.06094L4.4689 5.77969C4.76265 6.07344 5.23765 6.07344 5.52827 5.77969L9.25014 2.06094C9.72202 1.58906 9.38764 0.77969 8.71889 0.77969L1.2814 0.779691C0.612648 0.779691 0.278273 1.58907 0.750147 2.06094Z" fill={sortedColumn === 'LN' && sortDirection === 'DESC' ? "#F6A293" : "#344F7A"} fill-opacity={sortedColumn === 'LN' && sortDirection === 'DESC' ? 1 : 0.4} />
              </svg>
            </Flex>
          </Flex>
          {filterBy === 'LN' && (
            <InputNoForm type="search" style={{
              padding: '2px 6px',
              marginTop: '6px',
              border: '1px solid #7992B3',
            }} value={filter || ''} onChange={(e: any) => setFilter(e.target.value)} />
          )}
        </Box>
        <Box style={{ width: '1px', background: 'transparent' }}></Box>
        <Box style={{ flex: 1, paddingLeft: '12px', alignSelf: 'center' }}>
          <Flex flexDirection={'row'}>
            <Text style={{ color: '#7992B3', fontSize: '12px' }} ml={2}>DOB</Text>
          </Flex>
        </Box>
        <Box style={{ width: '1px', background: 'transparent' }}></Box>
        <Box width={'280px'} style={{ paddingLeft: '12px', alignSelf: 'center' }}>
          <Flex flexDirection={'row'}>
            <Text style={{ color: '#7992B3', fontSize: '12px' }} ml={2}>Phone</Text>
          </Flex>
        </Box>
        <Box style={{ width: '1px', background: 'transparent' }}></Box>
        <Box width={'280px'} style={{ paddingLeft: '12px', alignSelf: 'center' }}>
          <Flex flexDirection={'row'}>
            <Text style={{ color: '#7992B3', fontSize: '12px' }} ml={2}>State</Text>
          </Flex>
        </Box>
      </Flex>
    </>
  )
}

export const SearchResults: React.FC<ISearchResultsProps> = ({ data, error, searched }) => {
  const [sortBy, setSortBy] = useState<TSortColumn>(null)
  const [hoveredRow, setHoveredRow] = useState<string | null>(null)
  const [sortDirection, setSortDirection] = useState<TSortDirection>('ASC')
  const [filterBy, setFilterBy] = useState<TSortColumn>(null)
  const [filter, setFilter] = useState<string | null | undefined>()
  const navigate = useNavigate()

  if (!!error) {
    return (
      <Flex flex={1} justifyContent='center' alignItems={'center'}>
        <Text fontSize={'24px'} fontWeight={500}>An error occured</Text>
      </Flex>
    )
  }

  if (!data || !data.searchProviderPatientsByName) {
    return (
      <Flex flex={1} justifyContent='center' alignItems={'center'}>
        <Text fontSize={'24px'} fontWeight={500}>No Results Returned</Text>
      </Flex>
    )
  }

  const onSortChanged = (sortedColumn: TSortColumn) => {
    if (sortedColumn !== sortBy) {
      setSortBy(sortedColumn)
      setSortDirection('ASC')
    } else {
      setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC')
    }
  }

  return (
    <Flex flex={1} flexDirection='column'>
      <Flex display={['none!important', 'flex !important', 'flex !important']}>
        <Box style={{ background: '#BCFFEB', borderRadius: '10px', padding: '0 12px', height: '24px' }}>
          <Text color={'#4AA98C'}>{data.searchProviderPatientsByName.length}</Text>
        </Box>
        <Text fontWeight={300}>&nbsp;{`patient${data.searchProviderPatientsByName.length < 2 ? '' : 's'} found matching the search`}&nbsp;</Text>

        <Text fontWeight={500}>{`${searched}`}</Text>
      </Flex>
      <Flex display={['flex !important', 'none!important', 'none!important']}>
        <Box style={{ background: '#BCFFEB', borderRadius: '10px', padding: '0 12px', height: '24px' }}>
          <Text color={'#4AA98C'}>{data.searchProviderPatientsByName.length}</Text>
        </Box>
        <Text fontWeight={300}>
          &nbsp;{`patient${data.searchProviderPatientsByName.length < 2 ? '' : 's'} found matching the search`}&nbsp;<span style={{ fontWeight: 500 }}>{searched}</span>
        </Text>
      </Flex>
      <Header sortedColumn={sortBy} sortDirection={sortDirection} filter={filter} filterBy={filterBy} setFilter={setFilter} setFilterBy={setFilterBy} changeSort={onSortChanged} />
      {(JSON.parse(JSON.stringify(data.searchProviderPatientsByName)) as Array<ISearchPatient>).filter(x => {
        if (!filterBy || !filter) return x

        let parameter: keyof (ISearchPatient) = 'patientId'

        if (filterBy === 'ID') {
          parameter = 'patientId'
        } else if (filterBy === 'FN') {
          parameter = 'firstName'
        } else if (filterBy === 'LN') {
          parameter = 'lastName'
        }

        if (x[parameter] && (x[parameter] || '').toString().toLowerCase().indexOf(filter.toString().toLowerCase()) > -1) return x
        return false
      }).sort((a: ISearchPatient, b: ISearchPatient) => {
        if (!sortBy) return 0

        let parameter: keyof (ISearchPatient) = 'patientId'

        if (sortBy === 'ID') {
          parameter = 'patientId'
        } else if (sortBy === 'FN') {
          parameter = 'firstName'
        } else if (sortBy === 'LN') {
          parameter = 'lastName'
        }

        if (sortDirection === 'ASC') {
          if (!a[parameter] as any) return -1
          if (!b[parameter] as any) return 1
          if (a[parameter]! < b[parameter]!) {
            return -1
          } else {
            return 1
          }
        } else {
          if (!a[parameter]) return 1
          if (!b[parameter]) return -1
          if (a[parameter]! < b[parameter]!) {
            return 1
          } else {
            return -1
          }
        }
      }).map((x: ISearchPatient) => {
        return <Row hoveredId={hoveredRow} setHover={setHoveredRow} row={x} key={x.patientId}
          onGoToMessages={() => {
            navigate(`/messages/${x.patientId}&s=true&target=ai`)
          }}
          onGoToProfile={() => {
            navigate(`/patient/${x.patientId}`)
          }} />
      })}
    </Flex>
  );
}